// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               v7.35.1
// source: cairn/v1/sync_token.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Role, roleFromJSON, roleToJSON } from "./sync";

export const protobufPackage = "cairn.v1";

/**
 * Compact signed sync-token claims (control-plane spec §Sync token format).
 * Encoded as: "cairn_sync_" + base64url(SyncTokenClaims) + "." +
 * base64url(ed25519 signature). Not JWT-the-standard: no alg agility by
 * design. The data plane holds the ed25519 public key and verifies.
 */
export interface SyncTokenClaims {
  /** ULID */
  userId: string;
  /** ULID; MUST match the /sync/<vault-id> URL */
  vaultId: string;
  /** vault role at mint time */
  role: Role;
  /** unix seconds; ~10 min TTL */
  exp: number;
  /** unique token id (ULID), for future revocation lists */
  jti: string;
}

function createBaseSyncTokenClaims(): SyncTokenClaims {
  return { userId: "", vaultId: "", role: 0, exp: 0, jti: "" };
}

export const SyncTokenClaims: MessageFns<SyncTokenClaims> = {
  encode(message: SyncTokenClaims, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.vaultId !== "") {
      writer.uint32(18).string(message.vaultId);
    }
    if (message.role !== 0) {
      writer.uint32(24).int32(message.role);
    }
    if (message.exp !== 0) {
      writer.uint32(32).int64(message.exp);
    }
    if (message.jti !== "") {
      writer.uint32(42).string(message.jti);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SyncTokenClaims {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSyncTokenClaims();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.vaultId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.exp = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.jti = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SyncTokenClaims {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      vaultId: isSet(object.vaultId)
        ? globalThis.String(object.vaultId)
        : isSet(object.vault_id)
        ? globalThis.String(object.vault_id)
        : "",
      role: isSet(object.role) ? roleFromJSON(object.role) : 0,
      exp: isSet(object.exp) ? globalThis.Number(object.exp) : 0,
      jti: isSet(object.jti) ? globalThis.String(object.jti) : "",
    };
  },

  toJSON(message: SyncTokenClaims): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.vaultId !== "") {
      obj.vaultId = message.vaultId;
    }
    if (message.role !== 0) {
      obj.role = roleToJSON(message.role);
    }
    if (message.exp !== 0) {
      obj.exp = Math.round(message.exp);
    }
    if (message.jti !== "") {
      obj.jti = message.jti;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SyncTokenClaims>, I>>(base?: I): SyncTokenClaims {
    return SyncTokenClaims.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SyncTokenClaims>, I>>(object: I): SyncTokenClaims {
    const message = createBaseSyncTokenClaims();
    message.userId = object.userId ?? "";
    message.vaultId = object.vaultId ?? "";
    message.role = object.role ?? 0;
    message.exp = object.exp ?? 0;
    message.jti = object.jti ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
